import React, { useEffect } from 'react';
import { useStore } from '../../../../stores/root';

// assets

// services

// props

// components
import { Stack } from '@fluentui/react';
import EmployeePayslipsList from '../../../hr/payslips/general/list';

type MyPayslipsListProps = {

}

const MyPayslipsList: React.FC<MyPayslipsListProps> = (props: MyPayslipsListProps) => {
    const {user} = useStore();

    return <Stack>
        {user.data ? <EmployeePayslipsList qs={['employee_id=' + user.data.id]}
            columns={['id', 'contract', 'amount', 'status']}
            hideCommandBar /> : null}
    </Stack>
};

export default MyPayslipsList;
